import React, { useEffect, useState } from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from "react-notifications";
import axios from "axios";

export const POColumns = (handleEdit, handleDelete, handleApprove, handleDeny) => {
  const navigate = useNavigate();

  // Correctly passing poExceptionId and navigating
  const handleLinkClick = (poNumber, poExceptionId) => {
    navigate(`/exceptions/${poExceptionId}`); // Navigating to the correct route with poExceptionId
  };
  const [storeMap, setStoreMap] = useState({}); // Map of store_number to store name

  

  return [
    {
      field: 'po_number',
      headerName: 'PO Number',
      width: 200,
      sortable: false,
      renderCell: (params) => {
        const { po_number, po_exception_id } = params.row; // Extract values from row
        return (
          <div
            style={{
              textDecoration: 'none',
              color: '#2196f3',
              cursor: 'pointer',
            }}
            onClick={() => handleLinkClick(po_number, po_exception_id)} // Directly use handleLinkClick to navigate
          >
            {po_number}
          </div>
        );
      },
    },
    { field: 'department_number', headerName: 'Department Number', minWidth: 150, sortable: true },
    {
      field: 'name',
      headerName: 'Store Number',
      minWidth: 200,
      sortable: true,
      renderCell: (params) => {
        // Safely display store_list
        const storeList = params.row.store_list;
        return <span>{storeList}</span>;
      },
    },
    
    
    
    // { field: 'store_number', headerName: 'Store Number', minWidth: 150, sortable: true },
    {
      field: 'created_at',
      headerName: 'Request Date',
      minWidth: 150,
      sortable: true,
      renderCell: (params) => {
        const dateValue = params.value ? new Date(params.value) : null;
        const formattedDate = dateValue ? dateValue.toISOString().split('T')[0] : '';
        return <span>{formattedDate}</span>;
      },
    },
    { field: 'status', headerName: 'Routing Status', minWidth: 150, sortable: true },
    { field: 'po_status', headerName: 'PO Status', minWidth: 150, sortable: false },
    { field: 'supplier_site_id', headerName: 'Supplier Site ID', minWidth: 150, sortable: false },
    
  ];
};
